var tileData = new Map();

/*
tileData.set('Category Name', [
  {
    img: 'img-name.jpg',
    title: '',
    author: 'Steven Raden',
    cols: 2,
  },
]);
*/



// tileData.set('street', [
//   {
//     img: 'envy.jpg',
//     title: 'Seagull watching a man eating fries on a beach',
//     author: 'Steven Raden',
//     cols: 2,
//   },
//   {
//     img: 'fishing.jpg',
//     title: 'Fishing boat on the water in the morning',
//     author: 'Steven Raden',
//     cols: 2,
//   },
// ]);
  
tileData.set('Wildlife', [
  {
    img: 'forest-squirrel.jpg',
    title: 'Squirrel eating a nut in a dark forest',
    author: 'Steven Raden',
    cols: 2,
  },
  
  {
    img: 'hornsby-1.jpg',
    title: 'Carolina Wren sitting on a log amongst yellow flowers',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'hornsby-2.jpg',
    title: 'Red Cardinal in the forest',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'hornsby-4.jpg',
    title: 'Female Cardinal with an orange beak and red head flair.',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1073550.jpg',
    title: 'Bird sitting on a branch looking at a bird feeder',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1073559.jpg',
    title: 'White cat stalking a bird feeder along a fence',
    author: 'Steven Raden',
    cols: 2,
  },
]);
  
tileData.set('Band Photos', [
  {
    img: 'P1071897.jpg',
    title: 'Guitarist from the Coffin Fits with red light beams going over his head',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1071920.jpg',
    title: 'Coffin Fits band on stage',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1072513.jpg',
    title: 'Coffin fits band playing in black and white',
    author: 'Steven Raden',
    cols: 2,
  },
]);
  
tileData.set('Portraits', [
  {
    img: 'P1000515.jpg',
    title: 'Model walking pose',
    author: 'Steven Raden',
    imgPosition: '0px 0px',
    cols: 2,
  },
  {
    img: 'PC Class-2.jpg',
    title: 'Model in western attire looking through prison bars',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'PC Class-4.jpg',
    title: 'Model in western attire sitting on a wood walkway with luggage',
    author: 'Steven Raden',
    imgPosition: '0px 0px', 
    cols: 2,
  },
]);

tileData.set('Landscapes', [
  {
    img: 'austin-dam.jpg',
    title: 'Ladybird lake damn black and white',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'austin-skyline.jpg',
    title: 'Austin downtown at sunset with light reflacting in skyscraper windows',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'forgotten-wheel.jpg',
    title: 'An old fashioned tire, covered in moss, sitting in the woods',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'half-moon.jpg',
    title: 'Picture of a half moon',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'italy-cinque.jpg',
    title: 'Cinque Terre colorful waterside town with docks',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'italy-florence.jpg',
    title: 'River in Florence with cloudy sky and bridges',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'whidbey-christmas-2021-1.jpg',
    title: 'Old well house in the snow',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1000420.jpg',
    title: 'River on a misty day',
    author: 'Steven Raden',
    cols: 2,
  },
]);
  
tileData.set('Other', [
  {
    img: 'kizer-knife.jpg',
    title: 'Blade of a knife with the Kizer logo.',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1071520.jpg',
    title: 'Blade of a knife with the Kizer logo highlighted',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1072164.jpg',
    title: 'Close up of old fashione card headlight',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1072180.jpg',
    title: 'Old fashioned plane propellers',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1072422.jpg',
    title: 'Hotel rooms with private pools',
    author: 'Steven Raden',
    cols: 2,
  },
  {
    img: 'P1072477.jpg',
    title: 'Hotel rooms three floors high',
    author: 'Steven Raden',
    cols: 2,
  },
]);
  
export default tileData;